import Axios from 'axios'
import * as mutations from '../store/commitTypes'
import { store } from '../store/store'
const BASE_URL = 'web/v1/'
const axios = Axios.create({
    baseURL: BASE_URL,
})

axios.interceptors.request.use(
    config => {
        store.commit(mutations.ADD_ACTIVE_REQUESTS)
        return config
    },
    error => {
        store.commit(mutations.SUB_ACTIVE_REQUESTS)
        Promise.reject(error)
    }
)

axios.interceptors.response.use(
    response => {
        store.commit(mutations.SUB_ACTIVE_REQUESTS)
        return response
    },
    error => {
        store.commit(mutations.SUB_ACTIVE_REQUESTS)
        return new Promise((resolve, reject) => {
            const {
                config,
                response,
            } = error
            const originalRequest = config
            if (response && response.status === 419) {
                Axios.get('regenerate-session').then(response => {
                    const newToken = response.data
                    window.axios.defaults.headers.common[
                        'X-CSRF-TOKEN'
                    ] = newToken
                    document
                        .querySelector('meta[name=csrf-token]')
                        .setAttribute('content', newToken)
                    originalRequest.headers['X-CSRF-TOKEN'] = newToken
                    const newUrl = originalRequest.url.replace(BASE_URL, '')
                    originalRequest.url = newUrl
                    // resolve(window.axios({
                    //     method: originalRequest.method,
                    //     url: originalRequest.url,
                    //     data: originalRequest.data
                    // }));
                    resolve(axios(originalRequest))
                })
                //toastr.error('Su sesión ha expirado, por favor refresque la página e intente nuevamente');
            } else {
                reject(error)
            }
        })
    }
)

// axios.interceptors.request.use(config => {
//     const socketId = window.Echo.socketId();

//     if(!socketId) return config;

//     config.headers['X-Socket-ID'] = socketId;
//     return config;
// });

export { axios }
